// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1jbed","checkboxCol":"Table_checkboxCol__3KYKo","emailCol":"Table_emailCol__THP2Y","actionCol":"Table_actionCol__Ff35v"};